'use strict';
/* eslint no-sync: 0 */

/**
 * 
 * http://angular-ui.github.io/ui-grid/
 * 
 */

import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';
import uuid from 'uuid/v4';

class Message {
  constructor(message, type){
    this.message = message;
    this.type    = type || 'danger';
    this.id      = uuid();
  }
}

export class AlertMessagesComponent {
  timeout: Function;
  messages = [];

  /*@ngInject*/
  constructor(AlertMessageFactory, $timeout) {
    AlertMessageFactory.onAdd(this.onAddMessage.bind(this));
    this.timeout = $timeout;
  }

  onAddMessage(message, type, timeout) {
    var msg = new Message(message, type);
    this.messages.push(msg);

    if(timeout){
      this.timeout(() => {
        this.close(msg.id);
      }, timeout);
    }
  }

  close(id) {
    this.messages.forEach((msg, index) => {
      if(msg.id === id){
        this.messages.splice(index, 1);
      }
    });
  }
}

AlertMessagesComponent.$inject = ['AlertMessageFactory', '$timeout'];

export default angular.module('directives.alert-message', [uiBootstrap])
  .factory('AlertMessageFactory', function(){

    var onAdd = angular.noop;
    
    return {
      
      add: (message, type, timeout) => {
        return onAdd(message, type, timeout);
      },

      error: (error, timeout) => {
        console.log("DEBUG_ERROR:", error);
        var message = error;

        if(error.data && error.data.message){
          message = error.data.message;
        }

        if(error.message){
          message = error.message;
        }

        return onAdd(message, 'danger', timeout);
      },

      success: (message, timeout) => {
        return onAdd(message, 'success', timeout);
      },

      onAdd: (callback) => {
        onAdd = callback;
      },
    };
  })
  .component('alertMessages', {
    template: require('./alert-messages.html'),
    controller: AlertMessagesComponent,
    replace: true,
    transclude: true,
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/alert-messages/alert-messages.js